import { gql } from '@apollo/client';
import { BASE_PARTNER_COMPANY_FRAGMENT } from './partner.fragments';

export const GEO_DATA_ISSUE = gql`
  fragment geoDataIssueValues on GeoDataIssue {
    geoDataId
    siteId
    code
    entityId
    entityType
    message
    severityLevel
    additionalInfo
  }
`;

export const DATASET_TABLE_REPRESENTATION_CELL_FRAGMENT = gql`
  fragment datasetTableRepresentationCellValues on DatasetCell {
    value
    issues {
      severityLevel
      issueMessage
      issueCode
    }
  }
`;

export const DATASET_TABLE_REPRESENTATION_FRAGMENT = gql`
  fragment datasetTableRepresentationValues on DatasetTableRepresentation {
    columnsNames
    rows {
      farmId {
        ...datasetTableRepresentationCellValues
      }
      farmName {
        ...datasetTableRepresentationCellValues
      }
      plotId {
        ...datasetTableRepresentationCellValues
      }
      plotName {
        ...datasetTableRepresentationCellValues
      }
      plotSizeHa {
        ...datasetTableRepresentationCellValues
      }
      geometryWkt {
        ...datasetTableRepresentationCellValues
      }
      farmSizeHa {
        ...datasetTableRepresentationCellValues
      }
      originClusterId {
        ...datasetTableRepresentationCellValues
      }
      numberOfFarmers {
        ...datasetTableRepresentationCellValues
      }
      additionalCrops {
        ...datasetTableRepresentationCellValues
      }
      landOwnership {
        ...datasetTableRepresentationCellValues
      }
      farmOwnerFullName {
        ...datasetTableRepresentationCellValues
      }
      farmOwnerFirstName {
        ...datasetTableRepresentationCellValues
      }
      farmOwnerLastName {
        ...datasetTableRepresentationCellValues
      }
      siteDescription {
        ...datasetTableRepresentationCellValues
      }
    }
  }
  ${DATASET_TABLE_REPRESENTATION_CELL_FRAGMENT}
`;

export const DATASET_COLUMN_MAPPING_FRAGMENT = gql`
  fragment datasetColumnMappingValues on ColumnsData {
    columnName
    columnDataExample
    mappedColumnName
  }
`;

export const BASE_DATASET = gql`
  fragment baseDatasetValues on Dataset {
    id
    createdTimestamp
    modifiedTimestamp
    createdById
    title
    originCountry
    ownedBy {
      ...basePartnerCompanyValues
    }
    rawMaterial {
      id
      title
      hsCodes {
        id
        code
        description
      }
    }
    status
    issues {
      ...geoDataIssueValues
    }
    issuesCount
    originalGeoDataId
    isDeletable
  }
  ${BASE_PARTNER_COMPANY_FRAGMENT}
  ${GEO_DATA_ISSUE}
`;

export const DATASET_FRAGMENT = gql`
  fragment datasetValues on Dataset {
    ...baseDatasetValues
    documents {
      id
      title
    }
  }
  ${BASE_DATASET}
`;

export const DATASET_PROCESSING_ERROR_FRAGMENT = gql`
  fragment datasetProcessingErrorValues on DatasetProcessingError {
    datasetId
    datasetErrors {
      entityId
      entityType
      errorMessage
      errorType
    }
  }
`;
